module.exports = __webpack_public_path__ + "img/logo-l.61dd8629.png";